// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".GcLIraXKx{cursor:pointer;display:flex;padding:14px}.GcLIraXKx:hover{color:rgba(255,255,255,0.9);background-color:var(--ui-subtle-hover)}.GcLIraXKx:active,.GcLIraXKx._72wUwxDJx{background-color:var(--ui-subtle-active-hover)}@media screen and (-ms-high-contrast: active){.GcLIraXKx{-ms-high-contrast-adjust:none;color:buttonText}.GcLIraXKx:hover{color:window;background-color:highlight}}._4eWj3TBhx{margin-bottom:10px;width:243px}._4eWj3TBhx>div:last-child{max-height:none}._6CUcXbo0x{background-color:var(--light-backdrop)}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"support-menu": "GcLIraXKx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-outline"] + "",
	"supportMenu": "GcLIraXKx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["focus-outline"] + "",
	"active": "_72wUwxDJx",
	"support-menu-list": "_4eWj3TBhx",
	"supportMenuList": "_4eWj3TBhx",
	"light-backdrop": "_6CUcXbo0x",
	"lightBackdrop": "_6CUcXbo0x"
};
module.exports = exports;
